import { Reducer } from 'redux';
import { ActionType, getType } from 'typesafe-actions';
import { CardActions } from './CardActions';
import CardStateHelper from './CardStateHelper';
import CardsHelper from '../../Utility/CardsHelper';
import { IGameState } from '../Game/IGameState';

export const cardsHelper = new CardsHelper();

export const cardReducer: Reducer<IGameState> = (
    state: IGameState,
    action: ActionType<typeof CardActions>
): IGameState => {
    state = {
        ...state,
        levelState: {
            ...state.levelState,
            cardsState: {
                ...state.levelState.cardsState,
                cards: { ...state.levelState.cardsState.cards },
                tasks: [], // Tasks are cleared each turn.
                turnScore: 0,
            },
        },
    };

    switch (action.type) {
        case getType(CardActions.playCard):
            state = CardStateHelper.playCard(state, action.payload);
            break;
        case getType(CardActions.playBooster):
            state = CardStateHelper.playBooster(state, action.payload, {});
            break;
        case getType(CardActions.setCardInStackByIndex):
            state = {
                ...state,
                levelState: {
                    ...state.levelState,
                    cardsState: CardStateHelper.setCardInStackByIndex(state.levelState.cardsState, action.payload, action.meta)
                }
            }
            break;
        case getType(CardActions.discardCards):
            let cardsState = CardStateHelper.setCardDiscarded(
                state.levelState.cardsState,
                ...action.payload
            );
            cardsState = CardStateHelper.checkCardsObscured(cardsState);
            cardsState = CardStateHelper.updateCards(cardsState);
            state = CardStateHelper.updateGameState(state, cardsState);
            break;
    }
    return {
        ...state,
        levelState: {
            ...state.levelState,
            score:
                state.levelState.score + state.levelState.cardsState.turnScore,
        },
    };
};
